
import React, {useState ,useEffect} from 'react';
import {Link} from "react-router-dom";

import DomainTablePage from '../../components/domainTablePage.js'
import {TechnologyDomains} from '../../../../server/routes/route-types.js'

import {RtCVEWebsitesPageResult} from '../../../../server/routes/cve.js'

interface CVEWebsitesProps {
	server: string;
	pageData: unknown;
}

export default function CVEWebsites({server, pageData}: CVEWebsitesProps) {

	let [data, setData] = useState(pageData as RtCVEWebsitesPageResult);

	return (
        <>
            <DomainTablePage 
                domainList={data.TechnologyDomains}
            />
        </>
	)
}
